import { render, staticRenderFns } from "./MyLeft.vue?vue&type=template&id=223c641f&scoped=true"
import script from "./MyLeft.vue?vue&type=script&lang=js"
export * from "./MyLeft.vue?vue&type=script&lang=js"
import style0 from "./MyLeft.vue?vue&type=style&index=0&id=223c641f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223c641f",
  null
  
)

export default component.exports